const comments = [
  {
    name: '夜色微凉',
    avatar: 'YS',
    time: '2 天前',
    content: '日皮视频的蜜桃视频专区做得真的很用心，每天都有新内容更新，排行榜也很精准，基本上推荐的都对我的胃口。高清播放完全不卡，比之前用的其他平台体验好太多了。',
    tag: '蜜桃视频用户',
  },
  {
    name: '追风少年',
    avatar: 'ZF',
    time: '3 天前',
    content: '红桃视频的编辑力荐栏目是我每天必刷的，编辑团队品味真的不错，推荐的每部基本都是高分佳作。日皮视频整合了这么多频道的资源，一个网站就能看全，太方便了。',
    tag: '红桃视频用户',
  },
  {
    name: '星辰大海',
    avatar: 'XC',
    time: '5 天前',
    content: '最惊喜的是香蕉视频VIP频道的内容全免费了！之前要会员才能看的好多视频现在都能直接看，日皮视频这个福利真的太良心了。希望能一直保持下去，会推荐给更多朋友。',
    tag: '香蕉视频用户',
  },
  {
    name: '樱花落尽',
    avatar: 'YH',
    time: '1 周前',
    content: '作为樱花视频的老用户，在日皮视频上找到了好多之前没发现的好内容。新番速递更新特别快，基本同步上线，而且页面设计简洁清爽，浏览体验很舒服。强烈推荐！',
    tag: '樱花视频用户',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-100 font-heading mb-3">
            用户评价
          </h2>
          <p className="text-sm text-foreground-500 max-w-[480px] mx-auto">
            来自蜜桃视频、红桃视频、香蕉视频与樱花视频用户的真实反馈
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 md:gap-6 max-w-[1000px] mx-auto">
          {comments.map((item) => (
            <div
              key={item.name}
              className="p-5 md:p-6 rounded-xl bg-background-50 border border-background-200/60"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-500/15 text-primary-400 font-bold text-sm flex-shrink-0">
                  {item.avatar}
                </div>
                <div className="min-w-0">
                  <div className="flex items-center gap-2">
                    <span className="text-sm font-semibold text-foreground-100">{item.name}</span>
                    <span className="text-xs px-2 py-0.5 rounded bg-secondary-100/10 text-secondary-300 whitespace-nowrap">
                      {item.tag}
                    </span>
                  </div>
                  <span className="text-xs text-foreground-600">{item.time}</span>
                </div>
                <div className="flex-shrink-0 ml-auto flex items-center gap-0.5">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-xs text-primary-500"></i>
                  ))}
                </div>
              </div>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {item.content}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}